import { TripBookingDispatchPlaceIndividualTypeEnum } from '../../../lib/types/models/trip-booking/trip-date'
import { TripBookingDispatchPlace } from '../../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place'

export const extractTripBookingDispatchPlaceIndividualId = (
  dispatchPlace: TripBookingDispatchPlace
): number => {
  switch (dispatchPlace.individualType) {
    case TripBookingDispatchPlaceIndividualTypeEnum.ENROLLMENT:
      return dispatchPlace.enrollmentId
    case TripBookingDispatchPlaceIndividualTypeEnum.MISSION_TO_STAFF:
      return dispatchPlace.missionToStaffId
    case TripBookingDispatchPlaceIndividualTypeEnum.MISSION_TO_EXTERNAL_STAFF:
      return dispatchPlace.missionToExternalStaffId
    case TripBookingDispatchPlaceIndividualTypeEnum.MISSION_TO_LEC_STAFF:
      return dispatchPlace.missionToLecStaffId
    case TripBookingDispatchPlaceIndividualTypeEnum.AFFECTED_STAFF:
      return dispatchPlace.affectedStaffId
    default:
      throw new Error(
        `Unknown individual type: ${(dispatchPlace as TripBookingDispatchPlace).individualType}`
      )
  }
}
